// extracted by mini-css-extract-plugin
module.exports = {"wrap":"part-services-decor_wrap__ESPo2","container":"part-services-decor_container__rwSth","item":"part-services-decor_item__Kh7Iu"};